var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper inner" },
    [
      _c(
        "md-table",
        { staticClass: "context-menu-support custom-paginated-table" },
        [
          _c(
            "md-table-row",
            { staticClass: "table-header-row" },
            [
              _c("TableHeaderDropdown", {
                attrs: {
                  "column-icon": "keyboard_arrow_down",
                  "default-text": _vm.selectedColumn.name,
                  "dropdown-options": _vm.columnDropdownOptions,
                  "selected-option": _vm.selectedColumn,
                },
                on: { selectedOption: _vm.handleSelectedColumn },
              }),
              _c("md-table-head", [_vm._v("Status")]),
              _c("md-table-head", [_vm._v("Delivery Date")]),
              _c("md-table-head", [_vm._v("Address")]),
              _c("md-table-head", [_vm._v("Recipient")]),
            ],
            1
          ),
          _vm._l(_vm.orders, function (order) {
            return _c(
              "md-table-row",
              { key: order.orderId },
              [
                _c(
                  "md-table-cell",
                  [
                    _vm.selectedColumn.key == "order-number"
                      ? _c(
                          "router-link",
                          {
                            staticClass: "ref-link",
                            attrs: {
                              to: {
                                name: "Order Details",
                                params: { orderId: order.orderId },
                              },
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(order.orderNumber) +
                                "\n                "
                            ),
                          ]
                        )
                      : _c(
                          "router-link",
                          {
                            staticClass: "ref-link",
                            attrs: {
                              to: {
                                name: "Order Details",
                                params: { orderId: order.orderId },
                              },
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  order.sourceReference != null
                                    ? order.sourceReference
                                    : order.orderNumber
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
                _c("md-table-cell", [
                  _c(
                    "span",
                    {
                      staticClass: "custom-badge",
                      class:
                        "status-" + _vm.$_getBadgeStatusColor(order.status),
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(order.status) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("dateFormat")(
                          order.expectedDeliveryDate,
                          _vm.DATE_TYPES.standardDate
                        )
                      ) +
                      "\n            "
                  ),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(order.shippingAddress.address) +
                      "\n            "
                  ),
                ]),
                _c("md-table-cell", [
                  _vm._v(
                    "\n                " +
                      _vm._s(order.contact.name) +
                      "\n            "
                  ),
                ]),
              ],
              1
            )
          }),
          _vm.orders.length === 0
            ? _c(
                "md-table-row",
                [
                  _c("md-table-cell", { attrs: { colspan: "5" } }, [
                    _c("p", { staticClass: "no-result-message" }, [
                      _vm._v(
                        "No results matching your search/filter could be found."
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }